import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';

// Theme and config
import theme from './config/theme';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/admin/Dashboard';
import InvestorDashboard from './pages/investor/Dashboard';
import TestBackend from './pages/TestBackend';

// Contexts
import { MockDataProvider } from './contexts/MockDataContext';
import { AuthProvider } from './contexts/AuthContext';

// Protected Route Component
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <MockDataProvider>
          <Router>
            <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: 'background.default', width: '100%', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', maxWidth: '100%' }}>
                <Routes>
                {/* Landing Page */}
                <Route path="/" element={<HomePage />} />
                
                {/* Public Routes */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/test" element={<TestBackend />} />
                
                {/* Admin Routes - Protected & Admin Only */}
                <Route 
                  path="/admin/dashboard" 
                  element={
                    <ProtectedRoute requireAdmin={true}>
                      <AdminDashboard />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Investor Routes - Protected */}
                <Route 
                  path="/investor/dashboard" 
                  element={
                    <ProtectedRoute>
                      <InvestorDashboard />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Fallback redirect */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              </Box>
            </Box>
          </Router>
        </MockDataProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
